import React from 'react';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingScreen from '../components/loading';
import { textInResolution } from '../multiFunctions';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import {
    subscribeButton,
    divEmail,
    alreadySaveAreaDesktop
} from './newsLetterRegisterCSS';
import { paddingForInputs  } from '../multiFunctions';
import { subscribigText1 } from '../newsletter/text';
import addNewUser from '../endpoints-Calls/registry/index';
import validator from 'validator';

function NewsLetterRegister(props) {
  /* eslint-disable react/prop-types */
  let windowDimensions = props.windowDimensions;
  if (props.windowDimensions === undefined) {
    windowDimensions = {
        width: window.screen.width,
        height: window.screen.height
    }
  }

  const [inputError, setInputError] = useState('');
  const [saveValue, setsaveValue] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const [searchParams] = useSearchParams();
  const medium = searchParams.get('medium');
  const campaign = searchParams.get('campaign');
  const content = searchParams.get('content');

  let registryTextAreaStyle = {
    ...paddingForInputs,
    width: "90%",
    margin: "10px"
  }

  let subscriptionStyle = {
    fontSize: textInResolution("small", "large", "xx-large", "xx-large", windowDimensions), 
    fontFamily: 'calibri', 
    textAlign: "justify", 
    display: "inline-block", 
    width: "100%", 
    paddingBottom: "15px", 
    marginTop: "15px",
    fontWeight: "600",
  }
  let subscriptionButtonStyle = {
    fontSize: textInResolution("small", "large", "xx-large", "xx-large", windowDimensions),
  }
  const validateForm = async (e) => {
    setisLoading(true);
    if (!validator.isEmail(inputValue)) {
        setInputError('Error please add a valid email');
    }
    else {
        
        let inObj = {
            medium: medium,
            campaign: campaign,
            content: content,
            email: inputValue,
            isDiscount: props.isDiscount,
        }
        
        let result = await addNewUser(inObj);
        
        if (result.isOk) {
            setInputError('');
            setsaveValue(true);
        } else {
            setInputError(result.message);
        }
    }
    setisLoading(false);
  }
  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    setInputError("");
  };
  return (
    <>
    {isLoading && <LoadingScreen/> }
    {!saveValue && 
        <div style={{ paddingRight: "2%", paddingLeft: "2%" }}>
            {props.isSubscribeVisible && 
							<>
								<TextField 
                id="emailSubscription" 
                label="Enter your Email" 
                style={divEmail}
                value={inputValue}
                error={!!inputError}
                onChange={handleInputChange}
                helperText={inputError}
                variant="filled"
                InputProps={{ style: {registryTextAreaStyle}, disableUnderline: true }}/>
                <span style={subscriptionStyle}>{subscribigText1}</span>
								<div style={{ ...subscribeButton }}>
										<Button variant="contained" style={{ height: "45px", background: "#e2660e", width: "80%", ...subscriptionButtonStyle }} onClick={validateForm}>Subscribe</Button>
								</div>
							</>
            }
            
        </div>
    }
    {saveValue && 
        <div style={ alreadySaveAreaDesktop }>
            <span style={{ fontSize: "x-large" }}>Email Saved</span>
        </div>
    }
    </>
  )
}

export default NewsLetterRegister;